var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pj02_content",class:_vm.list.length > 2 ? '' : 'vh'},[_c('Header'),_c('Mian'),_c('p',{staticClass:"wire"}),_c('Link'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }